function PackageItem (name, price, quantity, productId, isVariable, variationParentName) {
  this.name = name;
  this.price = price;
  this.quantity = quantity;
  this.productId = productId;
  this.isVariable = isVariable;
  this.variationParentName = variationParentName;
}

export default PackageItem;